import { render, staticRenderFns } from "./admin-settings-modal.vue?vue&type=template&id=0b16ea34&scoped=true"
import script from "./admin-settings-modal.vue?vue&type=script&lang=ts"
export * from "./admin-settings-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16ea34",
  null
  
)

export default component.exports